/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Dec 28 2023
 **/

import { atom } from "jotai";

import { AlarmLogMessageValue } from "./types";

/**
 * @description Notification 데이터의 WS와 RestAPI 포멧이 달라, 이를 통일하기 위한 인터페이스
 */
export type NotificationItemPayload<T = unknown> = {
	readKey: string;
	relationId: string;
} & T;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type NotificationItem<T = any> = {
	type: AlarmLogMessageValue;
	payload: NotificationItemPayload<T>;
	createdTime: Date;
	read: boolean;
};

export type GNBNotificationItem = {
	id: string;
	title: string;
	content: React.ReactNode;
	createdAt: Date;
	isRead: boolean;
	onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
	meta?: object;
	avatar?: {
		name: string;
		imageSrc: string | undefined;
		type: string;
		colorLogo: string | undefined;
	};
	receivers?: {
		receivers: {
			id: string;
			name: string;
		}[];
		roomName: string;
		spaceName: string;
	};
	sender?: {
		id?: string;
		name?: string;
	};
	files?: {
		data: string;
		fileBoxId: string;
	}[];
	message?: string | null;
	users?: {
		id: string;
		name: string;
		colorProfile?: string;
		profileImagePath?: string;
	}[];
	roomId?: string;
	roomName?: string;
	spaceName?: string;
	spaceId?: string;
	inviteMessage?: string;
	approved?: boolean;
	roomType?: string;
	link?: string;
	sentTime?: number;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type NotificationAtomValue<T = any> = Map<string, NotificationItem<T>>;
export const NotificationAtom = atom<NotificationAtomValue>(new Map<string, NotificationItem>());
export const NotificationNoticeAtom = atom<NotificationAtomValue>(new Map<string, NotificationItem>());
export const NotificationSettingsAtom = atom(new Map<string, unknown>());
